import useResponsive from '../../../hooks/UseResponsive';
import BlockProps from '../../../models/BlockProps';
import BlockSNSData from './BlockSNSOldData';
import { useGetBase64Image } from '../../../hooks/UseGetBase64Image';
import Img from '../../Img';

export const generateIconItemId = (id: string, key: number) => `${id}-sns-icon-block-${key}`;

const BlockSNSOldPreview = (props: BlockProps) => {
  const {
    data,
  } = props;

  const blockData = data.data as BlockSNSData;
  const { icons } = blockData;

  const iconsItemIds = icons.map((icon, key) => generateIconItemId(data.id, key));

  useResponsive({
    items: iconsItemIds.map((iconsItemId) => ({
      wrapperId: `sns-icon-block-container-${data.id}`,
      targetId: iconsItemId,
      queries: [
        { size: 0, className: 'col-4' },
        { size: 500, className: 'col-sm-2' },
      ],
    })),
  });

  const leftPicBase64 = useGetBase64Image(blockData.leftPic?.value);
  const base64Image = useGetBase64Image(blockData.url?.value);

  return (
      <div
        className=""
        id="section-405"
        style={{
          overflow: 'hidden',
          backgroundImage: `url(${base64Image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="p-bgimg">
          <div className="p-wrapper p-wrapper-sm">
            <div className="p-inner">
              {blockData.title && (
                <div className="row align-items-center">
                  <div className="col-xs-12">
                    <div className="p-header text-center mb-4">
                      <div id="section-405-edit-item-1">
                        <h2>
                          <strong dangerouslySetInnerHTML={{ __html: blockData.title.value }} />
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="row align-items-center">
                {blockData.leftPic && (
                  <div className="col-xs-12 col-sm-6">
                    <div className="p-body">
                      <div className="p-img p-img-contain mb-4">
                        <label className="">
                          <img className="" src={leftPicBase64} alt="" style={{ objectPosition: 'unset' }} />
                        </label>
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-xs-12 col-sm-6">
                  <div className="p-body">
                    {blockData.rightSubTitle && (
                      <div className="mb-4 text-center">
                        <div id="section-403-edit-item-5">
                          <h3>
                            <strong
                              style={{ fontSize: '20px' }}
                              dangerouslySetInnerHTML={{ __html: blockData.rightSubTitle.value }}
                            />
                          </h3>
                        </div>
                      </div>
                    )}
                    {blockData.rightSubTitle2 && (
                      <div className="mb-4 text-center">
                        <div id="section-403-edit-item-5">
                          <h3>
                            <strong
                              style={{ fontSize: '20px' }}
                              dangerouslySetInnerHTML={{ __html: blockData.rightSubTitle2.value }}
                            />
                          </h3>
                        </div>
                      </div>
                    )}
                    {blockData.description && (
                      <div className="mb-4">
                        <div dangerouslySetInnerHTML={{ __html: blockData.description.value }} />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div id={`sns-icon-block-container-${data.id}`} className={`row align-items-stretch row-gap-4 justify-content-${blockData.iconsAlignment}`}>
                {icons && icons.map((icon, key) => (
                  <div id={generateIconItemId(data.id, key)} key={generateIconItemId(data.id, key)} className="sns-icon-item">
                    <div className="p-parts">
                      <div className="p-parts-item">
                        <div id="section-1001-003-001">
                          <div className="p-img">
                            <a target={icon.link?.linkData?.openType} href={icon.link?.linkData?.url}>
                              <Img src={icon.pic?.value || icon.iconUrl} alt="" style={{ objectFit: 'contain' }} />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="p-parts-item">
                        <div id="section-1001-003-002">
                          <div className="ql-align-center">
                            <strong dangerouslySetInnerHTML={{ __html: icon.title }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default BlockSNSOldPreview;
